// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

/**
 * `ChartZeroState` — the honest "no data yet" placeholder a snapshot-fed
 * chart panel (fitness / cost / agent-cost) renders before the first
 * `EvolutionCycleSnapshotEvent` lands (issue `per-panel-gating-t0`, US
 * §10). Replaces the retired global shell gate's single error alert: each
 * panel now shows its own zero-state, so a healthy pre-snapshot cycle
 * never looks broken. Never a fabricated zero — just a neutral message.
 */
export interface ChartZeroStateProps {
  message: string
}

export default function ChartZeroState({ message }: ChartZeroStateProps) {
  return (
    <div className="flex h-96 items-center justify-center text-sm text-text-tertiary">
      {message}
    </div>
  )
}
